import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';

import { ECrsStatus, ICrsDotaznik, crsDotaznikGet, crsDotaznikZalozit } from 'services/poDlt/crs';

import CrsDotaznik from './CrsDotaznik';
import CrsMajitel from './CrsMajitel';
import CrsOsoba from './CrsOsoby';
import CrsProhlaseni from './CrsProhlaseni';

interface ICrsFormular {}

const CrsFormular: React.FC<ICrsFormular> = () => {
    const { id } = useParams<{ id: string }>();
    const [loading, setLoading] = useState<boolean>(false);
    const [currentStep, setCurrentStep] = useState<number>(0);
    const [zadostID, setZadostID] = useState<number>(Number(id) || 0);
    const [dotaznikData, setDotaznikData] = useState<ICrsDotaznik>();

    const next = () => setCurrentStep(pv => pv + 1);
    const prev = () => setCurrentStep(pv => pv - 1);

    useEffect(() => {
        setLoading(true);
        if (isNaN(Number(id))) {
            // ak nemam idcko zalozim ziadost - neprejde ak je v url string) {
            setDotaznikData(undefined);
            setCurrentStep(0);
            crsDotaznikZalozit().then(resp => {
                setZadostID(resp.id);
                crsDotaznikGet(resp.id)
                    .then(response => {
                        setDotaznikData(response);
                    })
                    .finally(() => setLoading(false));
            });
        } else {
            crsDotaznikGet(zadostID)
                .then(response => {
                    setDotaznikData(response);
                })
                .finally(() => setLoading(false));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const steps = [
        {
            content: (
                <CrsMajitel
                    nextStep={next}
                    zadostID={zadostID}
                    setZadostID={setZadostID}
                    dotaznikData={dotaznikData!}
                />
            )
        },
        {
            content: (
                <CrsDotaznik
                    nextStep={next}
                    zadostID={zadostID!}
                    prevStep={prev}
                    dotaznikData={dotaznikData}
                    setDotaznikData={setDotaznikData}
                />
            )
        },
        ...(!(dotaznikData?.osobycr && dotaznikData?.stat === 'CZ')
            ? [
                  {
                      content: (
                          <CrsDotaznik
                              nextStep={next}
                              zadostID={zadostID!}
                              prevStep={prev}
                              dotaznikData={dotaznikData}
                              statutStep={true}
                              setDotaznikData={setDotaznikData}
                          />
                      )
                  }
              ]
            : []),
        ...((dotaznikData?.osobycr && dotaznikData.stat === 'CZ') ||
        !(dotaznikData?.statut === ECrsStatus.STS1A || dotaznikData?.statut === ECrsStatus.STS4)
            ? []
            : [
                  {
                      content: (
                          <CrsOsoba nextStep={next} prevStep={prev} zadostID={zadostID!} dotaznikData={dotaznikData!} />
                      )
                  }
              ]),
        {
            content: <CrsProhlaseni prevStep={prev} zadostID={zadostID!} dotaznikData={dotaznikData!} />
        }
    ];

    return (
        <LoadingWrapper loading={loading}>
            <Title level={3} text="DOTAZNIK_CRS" />

            {!loading && (
                <Row gutter={8}>
                    <Col span={24}>{steps[currentStep].content}</Col>
                </Row>
            )}
        </LoadingWrapper>
    );
};

export default CrsFormular;
